import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const DetailContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background-color: ${COLORS.bgSubtle};
`

export const DetailContents = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
  background-color: ${COLORS.bgWhite};
`

export const SectionDivider = styled.div`
  height: 8px;
  background-color: ${COLORS.bgSubtle};
`

export const DetailBottomBar = styled.div`
  padding: 12px 12px calc(8px + var(--safe-bottom, 0px));
  background-color: ${COLORS.bgWhite};
`

export const ActionRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  width: 100%;

  /*
   * 신청 취소 / 수량 변경 1:1 — grid 1fr 1fr 로 정확한 균등 분할.
   * flex(1 1 0) 는 버튼 자체의 flex:1 / width:100% 와 specificity 충돌 +
   * iOS WebView 의 unitless flex-basis flexbug 로 좌우 폭이 비대칭이 됨.
   * grid track 은 두 케이스 모두 무관하게 항상 동일 폭을 보장.
   * min-width:0 으로 grid item 의 기본 min-width:auto(콘텐츠 폭) 오버플로 차단.
   */
  > * {
    width: 100%;
    min-width: 0;
  }
`
